<template>
    <div>
        <v-container>
            <v-row justify="center" class="pa-6">
                <v-card width="650">
                <v-card-title class="headline">Translation Requests Summary</v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item v-for="(o, idx) in translationRequestSummary" :key="idx">
                            <v-list-item-content>
                                <v-list-item-title>{{ o.language }}</v-list-item-title>
                                <v-list-item-subtitle>Pending Translations: {{ o.translations }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>                    
                    <v-btn @click="getTranslationRequestSummary" color="primary">Refresh</v-btn>
                    <v-spacer></v-spacer>
                     <v-btn @click="model = true">Submit Translation Requests</v-btn>
                </v-card-actions>
            </v-card>
            </v-row>
            
        </v-container>
        <v-dialog width="350" persistent v-model="model">
            <v-card>
                <v-card-title class="headline">Update Translation Dictionary</v-card-title>
                <v-card-text>
                    <p>Are you sure you want to submit the requests for translation?</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateTranslationDictionary">Yes</v-btn>
                    <v-btn @click="model = false">No</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useTranslationStore } from '@/stores/translation'

const translationStore = useTranslationStore()

const translationRequestSummary = ref([])
const model = ref(false)

onMounted(() => {
    getTranslationRequestSummary()
})

const getTranslationRequestSummary = async () => {
    try {
        var res = await translationStore.getTranslationRequestSummary()
        translationRequestSummary.value = res.translationRequests
    } catch (error) {
        console.error('Error fetching translations request summary:', error)
    }
}

const updateTranslationDictionary = async () => {
    try {
        var res = await translationStore.updateTranslationDictionary()
        if (res.success) {
            model.value = false
            getTranslationRequestSummary() // Refresh the summary after updating
            console.log('Translation requests submitted successfully')
        } else {
            console.error('Failed to submit translation requests:', res.message)
        }

    } catch (error) {
        console.error('Error submitting translation request(s):', error)
    }
}

</script>